import { apiWrapper } from '../helper/api-wrapper';

export const getListTransactionVendor = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/design/transaction/vendor?orderType=${encodeURIComponent(
        payload?.orderType
      )}&type=${encodeURIComponent(payload?.type)}&query=${encodeURIComponent(
        payload?.query
      )}${
        payload?.startDate
          ? `&startDate=${encodeURIComponent(payload?.startDate)}`
          : ''
      }${
        payload?.endDate
          ? `&endDate=${encodeURIComponent(payload?.endDate)}`
          : ''
      }&sort=${encodeURIComponent(payload?.sort)}&offset=${encodeURIComponent(
        payload?.offset
      )}&limit=${encodeURIComponent(payload?.limit)}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getListTransactionDesigner = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/design/transaction?type=${encodeURIComponent(
        payload?.type
      )}&query=${encodeURIComponent(
        payload?.query
      )}&startDate=${encodeURIComponent(
        payload?.date
      )}&endDate=${encodeURIComponent(
        payload?.dateEnd
      )}&sort=${encodeURIComponent(payload?.sort)}&offset=${encodeURIComponent(
        payload?.offset
      )}&limit=${encodeURIComponent(payload?.limit)}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailTransactionVendor = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/design/transaction/balance/vendor?${
        payload?.startDate
          ? `startDate=${encodeURIComponent(payload.startDate)}`
          : ''
      }${
        payload?.endDate
          ? `&endDate=${encodeURIComponent(payload.endDate)}`
          : ''
      }`,
      payload?.orderType ? { orderType: payload?.orderType } : ''
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailTransactionDesigner = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/design/transaction/balance?startDate=${encodeURIComponent(
        payload?.date
      )}&endDate=${encodeURIComponent(payload?.dateEnd)}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailListTransactionVendor = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/design/transaction/balance/vendor?orderType=${encodeURIComponent(
        payload?.orderType
      )}&startDate=${encodeURIComponent(
        payload?.date
      )}&endDate=${encodeURIComponent(payload?.dateEnd)}`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailListTransactionDesigner = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/design/transaction/balance?startDate=${encodeURIComponent(
        payload?.date
      )}&endDate=${encodeURIComponent(payload?.dateEnd)}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailTransaction = async (id) => {
  try {
    const response = await apiWrapper.get(
      `merchants/design/transaction/detail/${parseInt(id)}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailBalanceDesigner = async () => {
  try {
    const response = await apiWrapper.get(
      `merchants/design/disbursement/balance`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailBalanceVendor = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/order/disbursement/balance`,
      payload?.orderType ? { orderType: payload?.orderType } : null
    );

    return response;
  } catch (error) {
    throw error;
  }
};
